import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.split";

// The phone's status bar (Android's Chrome and the home-screen app) takes the colour of the bar at the top of the
// screen: the header in the owners' look is another green than in the fans', and a wizard has its own bar. The
// manifest's theme_color (quasar.conf.js) is only the colour until the first page shows (#673, the user's phone,
// 28 Oct 2026). Read after every route change, again once a step's slide has ended.
var solid = function solid(el) {
  for (; el && el !== document.documentElement; el = el.parentElement) {
    var bg = getComputedStyle(el).backgroundColor;
    var alpha = (bg.match(/rgba?\(([^)]+)\)/) || ['', '0,0,0,0'])[1].split(',')[3];
    if (alpha === undefined || parseFloat(alpha) > 0) return bg;
  }

  return null;
};

export default (function (_ref) {
  var router = _ref.router;
  var meta = document.querySelector('meta[name="theme-color"]');

  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('name', 'theme-color');
    document.head.appendChild(meta);
  }

  var follow = function follow() {
    var colour = solid(document.elementFromPoint(window.innerWidth / 2, 1));
    if (colour && meta.getAttribute('content') !== colour) meta.setAttribute('content', colour);
  };

  var timers = [];

  var later = function later() {
    timers.forEach(clearTimeout);
    timers = [0, 400, 1200].map(function (ms) {
      return setTimeout(follow, ms);
    });
  };

  router.afterEach(later);
  window.addEventListener('resize', later);
  later();
});